// Transparent malady cutouts (assets/v10/maladies/cut), keyed like MALADY_ART:
// the subtype id, with `tool:subtype` overriding where a subtype id is shared.
import type { ImageSourcePropType } from 'react-native';
import { normalizeMaladyId } from '../olmps/spectrum-tools';

const CUT: Record<string, ImageSourcePropType> = {
  achlys: require('../../assets/v10/maladies/cut/achlys.png'),
  amathia: require('../../assets/v10/maladies/cut/amathia.png'),
  dysastria: require('../../assets/v10/maladies/cut/dysastria.png'),
  adrasteia: require('../../assets/v10/maladies/cut/adrasteia.png'),
  aergia: require('../../assets/v10/maladies/cut/aergia.png'),
  akrasia: require('../../assets/v10/maladies/cut/akrasia.png'),
  amechania: require('../../assets/v10/maladies/cut/amechania.png'),
  apate: require('../../assets/v10/maladies/cut/apate.png'),
  aporia: require('../../assets/v10/maladies/cut/aporia.png'),
  ate: require('../../assets/v10/maladies/cut/ate.png'),
  atlas: require('../../assets/v10/maladies/cut/atlas.png'),
  chaos: require('../../assets/v10/maladies/cut/chaos.png'),
  dysnomia: require('../../assets/v10/maladies/cut/dysnomia.png'),
  'nemos:akosmia': require('../../assets/v10/maladies/cut/dysnomia_nemos.png'),
  homados: require('../../assets/v10/maladies/cut/homados.png'),
  kakia: require('../../assets/v10/maladies/cut/kakia.png'),
  koalemos: require('../../assets/v10/maladies/cut/koalemos.png'),
  lethe: require('../../assets/v10/maladies/cut/lethe.png'),
  oistros: require('../../assets/v10/maladies/cut/oistros.png'),
  oizys: require('../../assets/v10/maladies/cut/oizys.png'),
  oknos: require('../../assets/v10/maladies/cut/oknos.png'),
  phthisis: require('../../assets/v10/maladies/cut/phthisis.png'),
  plane: require('../../assets/v10/maladies/cut/plane.png'),
};

export function maladyCutoutFor(subtypeId: string, toolId?: string): ImageSourcePropType | undefined {
  const id = toolId ? normalizeMaladyId(toolId, subtypeId) : subtypeId;
  return (toolId && CUT[`${toolId}:${id}`]) || CUT[id];
}
